@if ((field?.dirty || field?.touched) && field?.errors) {
<div class="error-messages position-relative">
  <span class="form-text invalid-tooltip d-block">
    @if (!hasDateErrors() && field.hasError('bsDate')) {
    <span>
      @if (field.getError('bsDate').invalid) {
      <span
        role="alert"
        aria-live="assertive"
        role="alert"
        aria-live="assertive"
      >
        {{
          errorMessage("INVALID_DATE", field.getError("bsDate"))
            | globalTranslate
        }}
      </span>
      } @if (field.getError('bsDate').minDate && !this.option) {
      <span>
        <span role="alert" aria-live="assertive">
          {{
            field.name === "statusGainDate" ||
            field.name === "paymentStartDate" ||
            field.name === "alimonyOrderDate" ||
            field.name == "startDate"
              ? (errorMessage("INVALID_DOB", field.getError("bsDate").minDate)
                | globalTranslate)
              : field.name === "dueDate"
              ? (errorMessage("PAST_DUE_DATE", field.getError("bsDate").minDate)
                | globalTranslate)
              : field.name === "incomeEndDate" ||
                field.name === "loseJobEndDate"
              ? (errorMessage(
                  "DATE_PAST_THREEMONTHS",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : field.name === "nextPregDueDate" ||
                field.name === "haveBabyDate" ||
                field.name === "pregEndDate"
              ? (errorMessage(
                  "TWELVE_MONTHS_MAX",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : field.name === "expDate" || field.name === "intendToReturnDate"
              ? (errorMessage(
                  "INVALID_MAX_DATE",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : field.name === "assetTransferDate" ||
                field.name === "careReceiveDate"
              ? (errorMessage(
                  "INVALID_START_DATE",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : field.name === "dateOfApplication"
              ? (errorMessage(
                  "INVALID_APPLICATION_DATE",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : field.name === "dateOfService"
              ? (errorMessage(
                  "INVALID_DATE_OF_SERVICE_MIN_DATE",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
              : (errorMessage(
                  "INVALID_MIN_DATE",
                  field.getError("bsDate").minDate
                ) | globalTranslate)
          }}
        </span>
      </span>
      } @if (field.getError('bsDate').maxDate) {
      <span role="alert" aria-live="assertive">
        {{
          field.name === "careReceiveDate" ||
          field.name === "alimonyOrderDate" ||
          field.name === "dateOfBirth" ||
          field.name === "birthDate" ||
          field.name === "statusGainDate" ||
          field.name === "nextPregDueDate" ||
          field.name === "haveBabyDate" ||
          field.name === "pregEndDate" ||
          field.name === "incomeEndDate" ||
          field.name === "assetTransferDate"
            ? (errorMessage(
                "INVALID_FUTURE_DATE",
                field.getError("bsDate").maxDate
              ) | globalTranslate)
            : field.name === "dueDate"
            ? (errorMessage("MAX_DATE_DUE", field.getError("bsDate").maxDate)
              | globalTranslate)
            : field.name === "dobDate"
            ? (errorMessage(
                "INVALID_MIN_DATE",
                field.getError("bsDate").maxDate
              ) | globalTranslate)
            : (errorMessage(
                "INVALID_FUTURE_DATE",
                field.getError("bsDate").maxDate
              ) | globalTranslate)
        }}
      </span>
      } @if (field.getError('bsDate').minDate && this.option &&
      this.option.errorMsg && this.option.errorMsg.INVALID_START_DATE) {
      <span role="alert" aria-live="assertive">
        <span
          >{{
            errorMessage("INVALID_START_DATE", field.getError("bsDate").minDate)
              | globalTranslate
          }}
        </span>
      </span>
      }
    </span>
    } @for (errorCode of errorCodes; track errorCode) {
    <span>
      @if (field.hasError(errorCode)) {
      <span role="alert" aria-live="assertive">
        {{
          errorMessage(errorCode, field.getError(errorCode)) | globalTranslate
        }}
        @if (errorCode === 'minlength') {
        <span>
          {{ errorMessage("minlength_count", field.getError("minlength")) }}
          {{
            errorMessage(
              "minlength_count_character",
              field.getError("minlength")
            ) | globalTranslate
          }}
        </span>
        } @if (errorCode === 'maxlength') {
        <span role="alert" aria-live="assertive">
          {{ errorMessage("maxlength_count", field.getError("maxlength")) }}
          {{
            errorMessage(
              "minlength_count_character",
              field.getError("maxlength")
            ) | globalTranslate
          }}
        </span>
        }
      </span>
      }
    </span>
    } @if (field.hasError('EQUITY_VALUE')) {
    <span role="alert" aria-live="assertive">
      {{
        errorMessage("EQUITY_VALUE", field.getError("EQUITY_VALUE"))
          | globalTranslate
      }}
    </span>
    }
  </span>
</div>
}